import { UInput } from '../../UInput.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderDefaultField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    const errorKey = ctx.errorKeyPrefix ? `${ctx.errorKeyPrefix}${key}` : key
    return (
        <UInput
            key={key}
            label={t(field.label)}
            type={field.type === 'email' ? 'email' : 'text'}
            value={ctx.form[key] as string}
            onChange={ctx.set(key)}
            fullWidth
            disabled={ctx.formDisabled}
            error={!!ctx.errors?.[errorKey]}
            slotProps={{
                htmlInput: {
                    'data-testid': getFieldTestId(ctx, key, 'input')
                }
            }}
            data-testid={getFieldTestId(ctx, key, 'uinput')}
        />
    )
}

export default renderDefaultField
